<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed" >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>拼团活动</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
    </div>
    <el-form :inline="true"  style="padding-top:30px"> 
      <div class="flex-r-x">
         <el-button icon="el-icon-plus" size="mini" type="primary" @click="sendNotice" v-if="q1 == true">添加活动</el-button>
      </div>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="'会员卡活动'" name="1" >
        </el-tab-pane>
        <el-tab-pane :label="'自定义活动'" name="2" >
        </el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini" v-if="loading == false"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                            <el-table-column label="标题" width="125" prop="Title"></el-table-column>
                            <el-table-column width="135" label="开始时间" prop="startTime"></el-table-column>
                            <el-table-column width="135" label="结束时间" prop="endTime"></el-table-column>
                            <el-table-column v-if="activeName == 1" label="会员卡名称" prop="CardName"></el-table-column>
                            <el-table-column label="原价" prop="CommodityPrice"></el-table-column>
                            <el-table-column label="库存" prop="inventoryCount"></el-table-column>
                            <el-table-column label="拼团人数" prop="maccount">
                                <template slot-scope="scope"  >
                                     <a style="font-weight:700;font-size:15px;color:#1890ff;cursor:pointer" @click="getActivityInfoClick(scope.row)">{{scope.row.maccount}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column label="开卡设置" v-if="activeName == 1" width="104" prop="kaikaType">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.kaikaType ==1">首次预约开卡</span>
                                    <span v-if="scope.row.kaikaType ==2">立即开卡</span>
                                    <span v-if="scope.row.kaikaType ==3">特定时间开卡：{{scope.row.kaikaTime}}</span>
                               </template>
                            </el-table-column>
                            <el-table-column label="发布人" prop="terName"></el-table-column>
                            <el-table-column label="状态" prop="isshelves">
                               <template slot-scope="scope">
                                     <el-tag  type="success" v-if="scope.row.state ==2">已上架</el-tag>
                                     <el-tag  type="danger" v-if="scope.row.state ==1">未上架</el-tag>
                               </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200" fixed="right">
                                <template slot-scope="scope" class="flexB">
                                    <span  v-if="q2 == true" class="set-link" @click="editGoodsTypeClick(scope.row)" >编辑</span>
                                    <span v-if="q3 == true"  class="set-link" @click="del(scope.row)" >删除</span>
                                    <span v-if="scope.row.state==1 && q4 == true" class="set-link" @click="ActivityInfoStateClick(scope.row)" >上架</span>
                                    <span  v-if="scope.row.state==2 && q4 == true" class="set-link" @click="ActivityInfoStateClick1(scope.row)" >下架</span>
                                    <span class="set-link" @click="upData(scope.row)" >下载活动二维码</span>
                                     <span class="set-link" @click="SpellInfoPhone(scope.row)" >核销查询</span>

                                </template>
                            </el-table-column>                     
    </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="添加活动"
            direction="ltr"
            size="60%"
            v-loading="loading1"
            :visible.sync="showDrawer"
            >
            <div class="drawerForm" style="padding-bottom:150px">
                <el-form :model="ruleFormGG" ref="ruleFormGG" :rules="rules" label-width="130px" label-position="right">
                  <el-form-item label="活动名称：" prop="Title">
                        <el-input size="small" v-model="ruleFormGG.Title" placeholder="输入标题" style="width:70%"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="活动类型：" prop="spType">
                        <el-radio-group size="small" v-model="ruleFormGG.spType"   > 
                            <el-radio label="1">会员卡</el-radio>
                            <el-radio label="2">无会员卡</el-radio>
                    
                         </el-radio-group>
                    </el-form-item> -->

                    <el-form-item v-if="ruleFormGG.spType == 1" label="会员卡：" prop="productId">
                        <el-select size="small" v-model="CardName" filterable  @change="changeCardID"  placeholder="请选择会员卡">
                            <el-option v-for="item in MemberCardList" :key="item.index" :label="item.CardName +'/￥'+item.SellingPrice " :value="item.ID+',' +item.CardName+','+item.SellingPrice">
                            </el-option>
                        </el-select>
                    </el-form-item>

                     <el-form-item label="原价：" prop="CommodityPrice">
                        <el-input size="small" style="width: 120px;" :disabled="ruleFormGG.spType == 1" v-model="ruleFormGG.CommodityPrice" placeholder="请输入价格"></el-input>
                    </el-form-item>

                    <el-form-item label="活动封面图：" prop="PicUrl">
                      <div class="list-img-box cursor">
                        <div v-if="ruleFormGG.PicUrl !== ''">
                          <img
                            :src="ruleFormGG.PicUrl "
                            style="width: 100px; height:100px"
                            alt="图片"
                              @click="uploadPicture('HeadUrl')"
                          />
                        </div>
                        <div
                          v-else 
                          class="upload-btn"
                          style="height: 100px;width:100px"
                          @click="uploadPicture('HeadUrl')"
                        >
                          <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                          <div class="flex-xy">
                            <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                              <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                        </div>

                          <!-- <span>封面设置</span> -->
                        </div>
                      </div>
                      <input
                        type="hidden"
                        v-model="ruleFormGG.PicUrl"
                        placeholder="请添加图片"
                      />
                    </el-form-item>
                    <el-form-item label="详情图片:" prop="mainImage">
                      <div class="flexc-cen-x">
                          <div class="list-img-box cursor">
                            <div v-if="img1 !== ''">
                              <img
                                :src="img1"
                              style="width: 121px; height: 81px"
                                alt="图片"
                                @click="uploadPicture('img1')"
                              />
                            </div>
                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img1')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                  <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>

                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                          <div class="list-img-box cursor" style="margin-left:10px">
                            <div v-if="img2 !== ''">
                              <img
                                :src="img2"
                                style="width: 121px; height: 81px"
                                alt="图片"
                                  @click="uploadPicture('img2')"
                              />
                            </div>

                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img2')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>

                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                          <div class="list-img-box cursor" style="margin-left:10px">
                            <div v-if="img3 !== ''">
                              <img
                                :src="img3"
                                style="width: 121px; height: 81px"
                                alt="图片"
                                @click="uploadPicture('img3')"
                              />
                            </div>
                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img3')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                              
                            <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>
                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="开始时间：" prop="startTime">
                        <el-date-picker
                          size="small"
                          v-model="ruleFormGG.startTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                          placeholder="选择日期时间"
                          default-time="08:00:00"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="endTime">
                        <el-date-picker
                          size="small"
                          v-model="ruleFormGG.endTime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                          type="datetime"
                          placeholder="选择日期时间"
                          default-time="21:00:00">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="阶梯拼团价：" prop="seckillPrice">
                        <el-button type="primary" size="mini" @click="addseckillPrice">添加</el-button>
                       <div>
                        满 <el-input style="width: 120px;" size="small" v-model="ruleFormGG.SpellGroupCount" placeholder="输入人数"></el-input>
                        <span >人成团 拼团价</span>
                       <el-input style="width: 120px;margin-left: 8px;" size="small" v-model="ruleFormGG.SpellGroupPrice" placeholder="输入金额"></el-input>
                       <span  >元</span>
                        </div>
                      <div v-if="isseckillPrice1">
                       满 <el-input style="width: 120px;" size="small" v-model="ruleFormGG.SpellGroupCount1" placeholder="输入人数"></el-input>
                        <span >人成团  拼团价</span>
                       <el-input style="width: 120px;margin-left: 8px;" size="small" v-model="ruleFormGG.SpellGroupPrice1" placeholder="输入金额"></el-input>
                       <span >元</span>
                        <i style="margin-left: 8px;" class="el-icon-delete"  @click="deleteSpellGroup()"></i>
                        </div>
                     </el-form-item>
                    <el-form-item label="库存：" prop="inventoryCount">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.inventoryCount" placeholder="输入库存"></el-input>
                    </el-form-item>

                    <el-form-item label="已售数量展示：" prop="VirtualCount">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.VirtualCount" placeholder="输入已售数量"></el-input>
                    </el-form-item>
                    
                     <el-form-item label="购买人限制：" prop="kaikaType">
                        <el-checkbox-group size="small" v-model="checkList">
                            <el-checkbox label="1">访客</el-checkbox>
                            <el-checkbox label="2">会员</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="开卡时间设置：" v-if="ruleFormGG.spType == 1" prop="kaikaType">
                         <el-radio-group size="small" v-model="ruleFormGG.kaikaType"   > 
                            <el-radio label="1">首次预约激活</el-radio>
                            <el-radio label="2">购买成功立即激活</el-radio>
                            <el-radio label="3">特定时间开卡激活</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="ruleFormGG.kaikaType==3 && ruleFormGG.spType == 1" label="开卡时间：" prop="kaikaTime">
                         <el-date-picker
                         size="small"
                            v-model="ruleFormGG.kaikaTime"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择开卡时间">
                        </el-date-picker>
                    </el-form-item>
                   <!-- <el-form-item label="是否限购：" prop="kaikaType">
                         <el-radio-group size="small" v-model="ruleFormGG.isxg"   > 
                            <el-radio label="1">是</el-radio>
                             <el-radio label="0">否</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item label="限购数量：" prop="xgCount" v-if="ruleFormGG.isxg == 1">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.xgCount" placeholder="输入限购数量"></el-input>
                    </el-form-item>-->

                    <el-form-item label="活动规则：" prop="acInfo" >
                       <el-input size="small" type="textarea" v-model="ruleFormGG.acInfo" style="width:70%"></el-input>
                    </el-form-item>
                     <el-form-item label="图文简介：" prop="Introduce" >
                        <Editor  :key="timer" v-bind:value="ruleFormGG.Introduce" v-model="ruleFormGG.Introduce"  style="margin-bottom:150px;margin-left:-40px">
                        </Editor>
                     </el-form-item>

                </el-form>
        <div class="demo-drawer__footer flex-r-x"  style="width:60%">
      <div>
          <el-button size="small" @click="showDrawer = false">取消</el-button>
           <el-button
       
            size="small"
            type="primary"
           @click="onSave('ruleFormGG')"
            >保存</el-button
          >
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
          @click="onPush('ruleFormGG')"
            >保存并上架</el-button
          >
  </div>
         
        </div>
            </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false
        class="normalDrawer"
        title="修改活动"
        direction="ltr"
        size="60%"
        v-loading="loading1"
        :visible.sync="editSHow"
      >
            <div class="drawerForm" style="padding-bottom:150px">
                <el-form :model="ruleFormGG" ref="ruleFormGG" :rules="rules" label-width="130px" label-position="right">
                  <el-form-item label="活动名称：" prop="Title">
                        <el-input size="small" v-model="ruleFormGG.Title" placeholder="输入标题" style="width:70%"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="活动类型：" prop="spType">
                        <el-radio-group size="small" v-model="ruleFormGG.spType"   > 
                            <el-radio label="1">会员卡</el-radio>
                            <el-radio label="2">无会员卡</el-radio>
                    
                         </el-radio-group>
                    </el-form-item> -->

                    <el-form-item v-if="ruleFormGG.spType == 1" label="会员卡：" prop="productId">
                        <el-select size="small" v-model="CardName" filterable  @change="changeCardID"  placeholder="请选择会员卡">
                            <el-option v-for="item in MemberCardList" :key="item.index" :label="item.CardName +'/￥'+item.SellingPrice " :value="item.ID+',' +item.CardName+','+item.SellingPrice">
                            </el-option>
                        </el-select>
                    </el-form-item>

                     <el-form-item label="原价：" prop="CommodityPrice">
                        <el-input size="small" style="width: 120px;" :disabled="ruleFormGG.spType == 1" v-model="ruleFormGG.CommodityPrice" placeholder="请输入价格"></el-input>
                    </el-form-item>

                    <el-form-item label="活动封面图：" prop="HeadUrl">
                      <div class="list-img-box cursor">
                        <div v-if="ruleFormGG.PicUrl !== ''">
                          <img
                            :src="ruleFormGG.PicUrl "
                            style="width: 100px; height:100px"
                            alt="图片"
                              @click="uploadPicture('HeadUrl')"
                          />
                        </div>
                        <div
                          v-else 
                          class="upload-btn"
                          style="height: 100px;width:100px"
                          @click="uploadPicture('HeadUrl')"
                        >
                          <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                          <div class="flex-xy">
                            <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                              <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                        </div>

                          <!-- <span>封面设置</span> -->
                        </div>
                      </div>
                      <input
                        type="hidden"
                        v-model="ruleFormGG.PicUrl"
                        placeholder="请添加图片"
                      />
                    </el-form-item>
                    <el-form-item label="详情图片:" prop="mainImage">
                      <div class="flexc-cen-x">
                          <div class="list-img-box cursor">
                            <div v-if="img1 !== ''">
                              <img
                                :src="img1"
                              style="width: 121px; height: 81px"
                                alt="图片"
                                @click="uploadPicture('img1')"
                              />
                            </div>
                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img1')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                  <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>

                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                          <div class="list-img-box cursor" style="margin-left:10px">
                            <div v-if="img2 !== ''">
                              <img
                                :src="img2"
                                style="width: 121px; height: 81px"
                                alt="图片"
                                  @click="uploadPicture('img2')"
                              />
                            </div>

                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img2')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>

                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                          <div class="list-img-box cursor" style="margin-left:10px">
                            <div v-if="img3 !== ''">
                              <img
                                :src="img3"
                                style="width: 121px; height: 81px"
                                alt="图片"
                                @click="uploadPicture('img3')"
                              />
                            </div>
                            <div
                              v-else 
                              class="upload-btn"
                              style="height: 100px;width:100px"
                              @click="uploadPicture('img3')"
                            >
                              <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                              
                            <div class="flex-xy">
                                <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                                  <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                            </div>
                              <!-- <span>封面设置</span> -->
                            </div>
                          </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="开始时间：" prop="startTime">
                        <el-date-picker
                        size="small"
                          v-model="ruleFormGG.startTime"
                          type="datetime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                         placeholder="选择日期时间"
                         default-time="08:00:00">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="endTime">
                        <el-date-picker
                        size="small"
                          v-model="ruleFormGG.endTime"
                          value-format="yyyy/MM/dd HH:mm:ss"
                          type="datetime"
                         placeholder="选择日期时间"
                           default-time="21:00:00">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="阶梯拼团价：" prop="seckillPrice">
                        <el-button type="primary" size="mini" @click="addseckillPrice">添加</el-button>
                       <div>
                        满 <el-input style="width: 120px;" size="small" v-model="ruleFormGG.SpellGroupCount" placeholder="输入人数"></el-input>
                        <span >人成团 拼团价</span>
                       <el-input style="width: 120px;margin-left: 8px;" size="small" v-model="ruleFormGG.SpellGroupPrice" placeholder="输入金额"></el-input>
                       <span  >元</span>
                        </div>
                      <div v-if="isseckillPrice1">
                       满 <el-input style="width: 120px;" size="small" v-model="ruleFormGG.SpellGroupCount1" placeholder="输入人数"></el-input>
                        <span >人成团  拼团价</span>
                       <el-input style="width: 120px;margin-left: 8px;" size="small" v-model="ruleFormGG.SpellGroupPrice1" placeholder="输入金额"></el-input>
                       <span >元</span>
                        <i style="margin-left: 8px;" class="el-icon-delete"  @click="deleteSpellGroup()"></i>
                        </div>
                     </el-form-item>
                    <el-form-item label="库存：" prop="inventoryCount">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.inventoryCount" placeholder="输入库存"></el-input>
                    </el-form-item>

                    <el-form-item label="已售数量展示：" prop="VirtualCount">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.VirtualCount" placeholder="输入已售数量"></el-input>
                    </el-form-item>
                    
                     <el-form-item label="购买人限制：" prop="kaikaType">
                        <el-checkbox-group size="small" v-model="checkList">
                            <el-checkbox label="1">访客</el-checkbox>
                            <el-checkbox label="2">会员</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="开卡时间设置："  v-if="ruleFormGG.spType == 1" prop="kaikaType">
                         <el-radio-group size="small" v-model="ruleFormGG.kaikaType"   > 
                            <el-radio label="1">首次预约激活</el-radio>
                            <el-radio label="2">购买成功立即激活</el-radio>
                            <el-radio label="3">特定时间开卡激活</el-radio>
                         </el-radio-group>
                    </el-form-item>
                   <!-- <el-form-item label="是否限购：" prop="kaikaType">
                         <el-radio-group size="small" v-model="ruleFormGG.isxg"   > 
                            <el-radio label="1">是</el-radio>
                             <el-radio label="0">否</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item label="限购数量：" prop="xgCount" v-if="ruleFormGG.isxg == 1">
                        <el-input size="small" style="width: 120px;"  v-model="ruleFormGG.xgCount" placeholder="输入限购数量"></el-input>
                    </el-form-item>-->
                    <el-form-item v-if="ruleFormGG.kaikaType==3 && ruleFormGG.spType == 1" label="开卡时间：" prop="kaikaTime">
                         <el-date-picker
                         size="small"
                            v-model="ruleFormGG.kaikaTime"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择开卡时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动规则：" prop="acInfo" >
                       <el-input size="small" type="textarea" v-model="ruleFormGG.acInfo" style="width:70%"></el-input>
                    </el-form-item>
                    <el-form-item label="图文简介：" prop="Introduce" >
                        <Editor  :key="timer" v-bind:value="ruleFormGG.Introduce" v-model="ruleFormGG.Introduce"  style="margin-bottom:150px;margin-left:-40px">
                        </Editor>
                    </el-form-item>
                </el-form>
        <div class="demo-drawer__footer flex-r-x"  style="width:60%">
      <div>
          <el-button size="small" @click="editSHow = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
          @click="edit('ruleFormGG')"
            >保存</el-button
          >
  </div>
         
        </div>
            </div>
    </el-drawer>
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
        <img
          :src="imgName"
          v-if="imgVisible"
          style="width: 100%"
          alt="查看"
        />
    </el-dialog>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
    </el-dialog>
    <el-dialog
      title="购买详情"
      :visible.sync="dialogminfoVisible"
      width="40%"
        >
            <el-table :data="ListMembersAcInfo" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;"  >
                <el-table-column label="姓名" prop="Name" >
                    <template slot-scope="scope" class="memberAvatar">
                                 <div style="  display: flex;align-items: center;">
                                    <el-avatar size="small" :src="defaultImg" v-if="scope.row.HeadUrl == '' || scope.row.HeadUrl==undefined"></el-avatar>
                                    <el-avatar size="small" :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl != '' && scope.row.HeadUrl!=undefined"></el-avatar>
                                    <span style="margin-left: 8px">{{scope.row.Name}}</span>
                                 </div>
                   </template>
                </el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>
                <el-table-column label="凑团人数" prop="SpellCount">
                           <template slot-scope="scope"  >
                                <a style="font-weight:700;font-size:15px;color:#1890ff;" @click="getSpellGroupCountInfoClick(scope.row)">{{scope.row.SpellCount}}</a>
                          </template>
                </el-table-column>
                <el-table-column label="购买时间" prop="addTime" ></el-table-column>
                <el-table-column label="是否成团" prop="istz">
                  <template slot-scope="scope"  >
                      <el-badge value="已成团" type="success" v-if="scope.row.inspectionstatus ==2"></el-badge>
                      <el-badge value="未成团" type="error" v-if="scope.row.inspectionstatus !=2"></el-badge>
                  </template>
                </el-table-column>
             </el-table>   
             <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
            </div>
    
    </el-dialog>
    <el-dialog
      title="凑团详情"
      :visible.sync="dialogmacidinfoVisible"
      width="40%"
        >
      <el-table :data="ListLadderSpellInfo" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;"  >
                <el-table-column label="姓名" prop="Name" >
                    <template slot-scope="scope" class="memberAvatar">
                                 <div style="  display: flex;align-items: center;">
                                    <el-avatar size="small" :src="defaultImg" v-if="scope.row.HeadUrl == '' || scope.row.HeadUrl==undefined"></el-avatar>
                                    <el-avatar size="small" :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl != '' && scope.row.HeadUrl!=undefined"></el-avatar>
                                     <span style="margin-left: 8px">{{scope.row.Name}}</span>
                                 </div>
                   </template>
                </el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>
                <el-table-column label="成员" prop="istz">
                    <template slot-scope="scope"  >
                        <el-badge value="团长" type="success" v-if="scope.row.istz ==1"></el-badge>
                        <el-badge value="团员" type="error" v-if="scope.row.istz ==0"></el-badge>
                    </template>
                  </el-table-column>
                 <el-table-column label="购买时间" prop="addTime" ></el-table-column>
                 <el-table-column label="付款状态" prop="inspectionstatus">
                    <template slot-scope="scope"  >
                        <el-badge value="已付款" type="success" v-if="scope.row.inspectionstatus !=3"></el-badge>
                        <el-badge value="已退款" type="error" v-if="scope.row.inspectionstatus ==3"></el-badge>
                        <el-badge value="已核销" type="primary" v-if="scope.row.inspectionstatus == 4"></el-badge>
                    </template>
                  </el-table-column>
                <el-table-column label="操作"  fixed="right">
                    <template slot-scope="scope" class="flexB">
                      <span  v-if="scope.row.inspectionstatus !=3 && scope.row.inspectionstatus !=4 && activeName == 2"  class="set-link" @click="hexiao(scope.row)" >核销</span> 
                      <span style="margin-left:10px"   v-if="scope.row.inspectionstatus !=3" class="set-link" @click="actkClick(scope.row)" >退款</span>
                    </template>
                </el-table-column>
             </el-table>   
          
    </el-dialog>
    <el-dialog
      title="核销详情"
      :visible.sync="dialogmacidinfoVisibleHX"
      width="40%"
        >
       <el-form :inline="true"   class="flex-spc-x"  >
      <div>
        <el-form-item label="搜索：">
          <el-input size="mini" v-model="Phone" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click="searchPhone">搜索</el-button>
          <!-- <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input> -->
        </el-form-item>
      </div>
      
    </el-form>
      <el-table :data="ListLadderSpellInfo" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;"  >
                <el-table-column label="姓名" prop="Name" >
                    <template slot-scope="scope" class="memberAvatar">
                                 <div style="  display: flex;align-items: center;">
                                    <el-avatar size="small" :src="defaultImg" v-if="scope.row.HeadUrl == '' || scope.row.HeadUrl==undefined"></el-avatar>
                                    <el-avatar size="small" :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl != '' && scope.row.HeadUrl!=undefined"></el-avatar>
                                     <span style="margin-left: 8px">{{scope.row.Name}}</span>
                                 </div>
                   </template>
                </el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>
                <el-table-column label="成员" prop="istz">
                    <template slot-scope="scope"  >
                        <el-badge value="团长" type="success" v-if="scope.row.istz ==1"></el-badge>
                        <el-badge value="团员" type="error" v-if="scope.row.istz ==0"></el-badge>
                    </template>
                  </el-table-column>
                 <el-table-column label="购买时间" prop="addTime" ></el-table-column>
                 <el-table-column label="付款状态" prop="inspectionstatus">
                    <template slot-scope="scope"  >
                        <el-badge value="已付款" type="success" v-if="scope.row.inspectionstatus !=3"></el-badge>
                        <el-badge value="已退款" type="error" v-if="scope.row.inspectionstatus ==3"></el-badge>
                        <el-badge value="已核销" type="primary" v-if="scope.row.inspectionstatus == 4"></el-badge>
                    </template>
                  </el-table-column>
                <el-table-column label="操作"  fixed="right">
                    <template slot-scope="scope" class="flexB">
                      <span  v-if="scope.row.inspectionstatus !=3 && scope.row.inspectionstatus !=4 && activeName == 2"  class="set-link" @click="hexiao(scope.row)" >核销</span> 
                      <span style="margin-left:10px"   v-if="scope.row.inspectionstatus !=3" class="set-link" @click="actkClick(scope.row)" >退款</span>
                    </template>
                </el-table-column>
             </el-table>   
          
    </el-dialog>
    <el-dialog title="核销" :visible.sync="heShow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="核销码" prop="password">
          <el-input size="small" placeholder="请输入核销码" v-model="VerificationCode"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="heShow = false">取消</el-button>
        <el-button size="small" type="primary"  @click="sureHexiao()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import  Editor from '../../components/editor'
import CropperImage from "../../components/CropperImage";
import Pagination from "../../components/Pagination";
 import { baseUrl } from "../../config/env.js";

export default {
  data() {
    return {
      heShow:false,
      VerificationCode:false,
      items:'',
      macid:[],
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
      },
      ListLadderSpellInfo:[],
      timer:'',
      tableData:[],
          activeName:'1',
      imgVisible:false,
      releForm:[],
      dialogmacidinfoVisible:false,
      dialogmacidinfoVisibleHX:false,
           SelectStoresID:localStorage.getItem("StoresID"),
            baseUrl,
            dialogminfoVisible:false,
                loading:false,
                searchContent:"",
                         isseckillPrice1:false,
                dialoglaoshiVisible:false,
                dialogxueyuanVisible:false,
                showDrawerGG:false,
                loading1:false,
                dialogtsVisible:false,
                dialogtsdxVisible:false,
                dialogfsqjVisible:false,
                dialogtkVisible:false,
                dialogfstkVisible:false,
                storeList:[],
                AnnouncementList:[],
                selectedStore:"",     
                selectedStoresName:"",           
                 checkList:['1','2'],
                selectedStore:"",   
                selectName:"",   
                ACid:"",  
                mid:"", 
                currentBaseImg:"",
                CardName:"",  
                AcTimeState : 0,               
                limit1: 10,
                count1:1,
                currentPage1:1,
                offset1:1,
                limit2: 10,
                count2:1,
                currentPage2:1,
                offset2:1,
             NoticeList:[],
                showDrawer:false,
            ruleFormGG:{
                Introduce:'',
                 ActivityInfoID:"",
                 StoresID:"",
                 Title:"",
                 startTime:"",
                 endTime:"",
                 PicUrl:"",
                 videoUrl:"",
                 productId:"",
                 AcType:"1",
                 LoginID:"",
                 state:"",
                 fxUrl:"",
                 inventoryCount:"0",
                 VirtualCount:"",
                 CommodityPrice:"",
                 seckillPrice:"",
                 applyType:"",
                 kaikaType:"1",
                 kaikaTime:"",
                 acInfo:"",
                  isxg:'0',
                 xgCount:1,
                 ListActivityImg:"",
                 SpellGroupCount:2,
                 SpellGroupPrice:"0",
                 SpellGroupCount1:0,
                 SpellGroupPrice1:"",
                 SpellGroupCount2:0,
                 SpellGroupPrice2:""
                } ,
                 pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
              
   
                showSelectTeacher:false,
                showSelectMember:false,
                showSelectClass:false,
                dialogbanjiVisible:false,
                options:[
                    {value:"1",label:"王老师"},
                    {value:"2",label:"陈老师"},
                ],
                teacherList:[],
                memberList:[],
                ListClass:[],
                rules:{
                    PicUrl: [{required: true, message:'请选择图片', trigger: 'blur' }],
                    sendType: [{required:true, message:'', trigger:'change'}],
                    Title: [{required: true, message:'请输入标题', trigger: 'blur' }],
                    // productId: [{required: true, message:'请选择商品', trigger: 'blur' }],
                    startTime:[{required: true, message:'选择开始时间', trigger: 'blur' }],
                    endTime:[{required: true, message:'选择结束时间', trigger: 'blur' }],
                },
                canSend:true,
                // iswebview:getStore("iswebview"),
                gettimes:"",
                multipleSelection:[],
                multipleSelection1:[],
                cmultipleSelection1:[],
                multipleSelection2:[],
                Limits:[],
                q1:false,
                q2:false,
                q3:false,
                q4:false,
                q5:false,
                q6:false,
                WZYGName:'',
                  offset1:1,
                limit2: 10,
                count2:1,
                currentPage2:1,
                offset2:1,
        WZHYName:'',
        WZXMName:'',
        WZPBName:'',
        cropperName:'',
        cropperModel:false,
        img1:'',
        img2:'',
        img3:'',
        ListMembersAcInfo:[],
        AcID:'',
        mid:'',
        Phone:'',
        editSHow:false,
    };
  },
  // 注册组件
  components: {
    Editor,
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
        if(localStorage.getItem('isAdmin') == 1){
          
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 =true
   
      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 178)
            this.q1  =true
            if(items == 179)
            this.q2 = true
            if(items == 11701)
            this.q3 = true
            if(items == 1702)
            this.q4 = true
            

      })
      

        this.getDianList()
        this.getCardList()
        this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    upData(row){
      window.open(row.fxUrl)
      // console.log('下载图片')
      //   let a = document.createElement("a");
      //   a.style.display = "none";
      //   a.download = '活动.png';
      //   a.href = row.fxUrl
      //   document.body.appendChild(a);
      //   a.click();
    },
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let img = new Image();
        img.crossOrigin = "Anonymous"; //允许跨域
        img.src = url;
        img.onload = function () {
          canvas.height = 300;
          canvas.width = 300;
          ctx.drawImage(img, 0, 0, 300, 300);
          let dataURL = canvas.toDataURL("image/png");
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    hexiao(items){
        this.VerificationCode = ''
        this.items = items
        this.heShow = true
    },
    sureHexiao(){
        var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  SpellInfoID:this.items.ID,
                  VerificationCode:this.VerificationCode,
                  LoginID:localStorage.getItem("LoginID"),
                }
                var that = this
                this.ajax('editMembersAcInfoHXPT.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.$message({
                        type: "success",
                        message: "核销",duration:2000,
                      });
                
                      that.getPersonList()
                      that.getListLadderSpellInfo();
                      that.heShow  = false
                    }
                })
    },
    handleClick(){

      this.pageparm ={
            currentPage: 1,
            pageSize: 10,
            total: 0,
      },

      this.getList()

    },

    addseckillPrice(){
                if(this.isseckillPrice1){
                   this.$alert('最多两阶阶梯', '提示', {
                     confirmButtonText: '关闭',
                    callback: action => {
             
                         }
                     });
                     return;
                }
                this.isseckillPrice1=true;
            },
            deleteSpellGroup(){
                this.ruleFormGG.SpellGroupCount1=0;
                this.ruleFormGG.SpellGroupPrice1=0;
                   this.isseckillPrice1=false;
            },
    editGoodsTypeClick(row){
      var that = this
  
      var data = { 

          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ACID:row.ID,
          sourceName:localStorage.getItem("Name"),
          sourceID:localStorage.getItem("LoginID"),
      }
            
      this.ajax('getActivityInfo.aspx',JSON.stringify(data),"POST",function(res){

        if (res.orsuccess == "1") {

            that.ruleFormGG = res.data

          }
    })
        // this.ruleFormGG=row;
        this.CardName=row.CardName;
        this.checkList=[];       
        var str1 = row.applyType;
        var arr1 = str1.split(',');
        if(arr1.length>0){
          this.$set( this,'checkList',arr1);
        }
                        if( this.ruleFormGG.SpellGroupCount1>0){
                    this.isseckillPrice1=true;
                } else {
                  this.isseckillPrice1 = false
                }
        if(row.listimg.length>0 && row.listimg[0].ImgUrl !='' ){
                that.img1 = row.listimg[0].ImgUrl
              } else {
                 that.img1 =""
              }
  if(row.listimg.length>1 && row.listimg[1].ImgUrl !=''){
   that.img2 = row.listimg[1].ImgUrl
              }else {
                 that.img2 =""
              }
                            if(row.listimg.length>2 && row.listimg[2].ImgUrl !=''){
           that.img3 = row.listimg[2].ImgUrl
              }else {
                 that.img3 =""
              }
              this.editSHow = true
                this.timer =  new Date().getTime()
    },
    actkClick(val){
        this.$confirm("确定要退款吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
        .then(() => {
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  ID:val.ID,
                  sourceName:localStorage.getItem("Name"),
                  sourceID:localStorage.getItem("LoginID"),
                }
                var that = this
                this.ajax('LadderSpellGroupAcinfoTK.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.$message({
                        type: "success",
                        message: "退款成功",duration:2000,
                      });
                
                      that.getPersonList()
                      that.getListLadderSpellInfo();
                      //  that.provinceList = res.data
                    }

                })
                })
          .catch(() => {
            ;
        });
                
    },
getSpellGroupCountInfoClick(val){
              this.macid= val.ID;
                this.getListLadderSpellInfo();
},    
getListLadderSpellInfo(){
  var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  macid:this.macid ,
                  AcID:this.AcID,
                }
                var that = this
                this.ajax('getListLadderSpellInfo.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                       that.ListLadderSpellInfo = res.data;
                        that.ListLadderSpellInfo.forEach(items => {
                        items.addTime = items.addTime.replace(/\//g, '-')
                
                      });
                       that.dialogmacidinfoVisible = true;
                    }

          })
},SpellInfoPhone(row){
    this.AcID = row.ID;
    this.Phone ='';
    this.ListLadderSpellInfo =[];
    this.dialogmacidinfoVisibleHX = true;

},searchPhone(){
this.getListLadderSpellInfoPhone();
},getListLadderSpellInfoPhone(){
  var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  Phone:this.Phone ,
                  AcID:this.AcID,
                }
                var that = this
                this.ajax('getListLadderSpellInfoPhone.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                       that.ListLadderSpellInfo = res.data;
                        that.ListLadderSpellInfo.forEach(items => {
                        items.addTime = items.addTime.replace(/\//g, '-')
                
                      });
                    }

          })
},


    handleSizeChange2(val){
        this.limit2 = val;
        this.currentPage2 = 1;
        this.offset2 = 1;
        this.getPersonList();
    },
     handleCurrentChange2(val) {
        this.currentPage2 = val;
        this.offset2 =val;
        this.getPersonList();
      },
    getActivityInfoClick(items){
      console.log(items)
          this.AcID = items.ID
          this.getPersonList()
    },
    getPersonList(){
       var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  pages:this.offset2, 
                  psize:this.limit2, 
                  state:2,
                  AcID:this.AcID,
                }
                var that = this
                this.ajax('getListMembersAcInfo.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.ListMembersAcInfo = res.data;
                      that.count2 =res.allcount;
                       that.ListMembersAcInfo.forEach(items => {
                        items.addTime = items.addTime.replace(/\//g, '-')
                
                   });
                      that.dialogminfoVisible = true;
                    }

          })
    },
    ActivityInfoStateClick(items){
        this.$confirm("确定要上架么?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
          .then(() => {
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  ActivityInfoID:items.ID,
                  state:2
                
                }
                var that = this
                this.ajax('editActivityInfoState.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.$message({
                        type: "success",
                        message: "上架成功",duration:2000,
                      });
                
                      that.getList()
                      //  that.provinceList = res.data
                    }

                })
                })
          .catch(() => {
            ;
        });
    },
    ActivityInfoStateClick1(items){
      this.$confirm("确定要下架么?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
          .then(() => {
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  ActivityInfoID:items.ID,
                  state:1
                
                }
                var that = this
                this.ajax('editActivityInfoState.aspx',JSON.stringify(data),"POST",function(res){

                  if (res.orsuccess == "1") {
                      that.$message({
                        type: "success",
                        message: "下架成功",duration:2000,
                      });
                
                      that.getList()
                      //  that.provinceList = res.data
                    }

                })
                })
          .catch(() => {
            ;
        });
    },
      getList(){
               const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var that = this
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectMembersName:this.selectMembersName,
          pages:this.formInline.page,
          psize:this.formInline.limit,
          AcType:2, 
          AcTimeState:0,
          selectName:'',
           spType:this.activeName,
      }

        this.ajax('getListActivityInfo.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.tableData = [...res.data]
              that.tableData.forEach(items => {
               items.startTime = items.startTime.replace(/\//g, '-')
                items.endTime = items.endTime.replace(/\//g, '-')
              });
              that.pageparm.total = res.allcount
             that.tableLoading = false
                 loading.close();

            }
      })
    },
     uploadPicture(name) {
     this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后
    handleUploadSuccess(data) {
       this.cropperModel = false

      if(this.cropperName == 'HeadUrl'){
          this.ruleFormGG.PicUrl = data.url
      }
      if(this.cropperName == 'img1'){
          this.img1 = data.url
      }
      if(this.cropperName == 'img2'){
          this.img2 = data.url
      }
      if(this.cropperName == 'img3'){
          this.img3 = data.url
      }

      this.cropperModel = false;
    },
    getCardList(){
        var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }

      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.MemberCardList= res.data
              

          } 
       })
    },
     changeCardID(val){
               // console.log(val)
                let arr1 = val.split(",");
                  if(arr1.length > 2){
                  this.ruleFormGG.productId = arr1[0];
                  this.CardName = arr1[1];
                  this.ruleFormGG.CommodityPrice = arr1[2];
                
               }
                

            },
  
    sendNotice(){
      
        this.ruleFormGG={
                 Introduce:'',
                 ActivityInfoID:"",
                 Title:"",
                 startTime:"",
                 spType:this.activeName,
                 endTime:"",
                 PicUrl:"",
                 videoUrl:"",
                 productId:"",
                 AcType:"2",
                 LoginID:localStorage.getItem("LoginID"),
                 state:"",
                 fxUrl:"",
                 inventoryCount:"0",
                 VirtualCount:"",
                 CommodityPrice:"",
                 seckillPrice:"",
                 applyType:"",
                 kaikaType:"1",
                 kaikaTime:"",
                 acInfo:"",
                 isxg:'0',
                 xgCount:1,
              
                 ListActivityImg:"",
                 SpellGroupCount:2,
                 SpellGroupPrice:"0",
                 SpellGroupCount1:0,
                 SpellGroupPrice1:"",
                 SpellGroupCount2:0,
                 SpellGroupPrice2:""
              }
              this.CardName = ''
              this.img1 = ''
              this.img2 =  ''     
              this.img3 = ''
              this.showDrawer = true
              this.isseckillPrice1 = false
            this.timer =  new Date().getTime()

    },
    mobandxinfo(ruleForm){
          this.dialogtsdxVisible = true
    },


    
 
 
         
   
    
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
 
 
  
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getList();
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.showDrawer = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.ruleFormGG.deptId = row.deptId;
        this.ruleFormGG.deptName = row.deptName;
        this.ruleFormGG.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.ruleFormGG.deptId = "";
        this.ruleFormGG.deptName = "";
        this.ruleFormGG.deptNo = "";
      }
    },
    edit(editData){
       var list = []
      if(this.img1 !='' && this.img1)
          list.push(this.img1) 
        // this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2 )
        list.push(this.img2) 
        // this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        list.push(this.img3) 
        this.ruleFormGG.ListActivityImg= list.join()
         this.ruleFormGG.applyType= this.checkList.join()

        // this.editForm.lbimgs = this.editForm.lbimgs  + this.img3 
   var that = this
      this.$refs[editData].validate(valid => {
        if (valid) {
           var data = this.ruleFormGG
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.ActivityInfoID = this.ruleFormGG.ID
            data.StoresID=localStorage.getItem("StoresID")
            this.ajax('editLadderSpellGroupAc.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editSHow = false
                                  that.getList()
                                }

                })

               

       
        } else {
          return false
        }
      })
    },
    onSave(editData) {
      var list = []
      if(this.img1 !='' && this.img1)
          list.push(this.img1) 
        // this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2 )
        list.push(this.img2) 
        // this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        list.push(this.img3) 
        this.ruleFormGG.ListActivityImg= list.join()
         this.ruleFormGG.applyType= this.checkList.join()
         this.ruleFormGG.state  = 1
        // this.editForm.lbimgs = this.editForm.lbimgs  + this.img3 
   var that = this
      this.$refs[editData].validate(valid => {
        if (valid) {
           var data =this.ruleFormGG
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
            this.ajax('addLadderSpellGroupAc.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  that.showDrawer = false
                                  that.getList()
                                }

                })

               

       
        } else {
          return false
        }
      })
     },
     onPush(editData) {
      var list = []
      if(this.img1 !='' && this.img1)
          list.push(this.img1) 
        // this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2 )
        list.push(this.img2) 
        // this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        list.push(this.img3) 
        this.ruleFormGG.ListActivityImg= list.join()
         this.ruleFormGG.applyType= this.checkList.join()
         this.ruleFormGG.state  = 2
        // this.editForm.lbimgs = this.editForm.lbimgs  + this.img3 

      this.$refs[editData].validate(valid => {
        if (valid) {
          var that = this
           var data = this.ruleFormGG
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
            this.ajax('addLadderSpellGroupAc.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  that.showDrawer = false
                                  that.getList()
                                }

                })

               

       
        } else {
          return false
        }
      })
     },
     del(items){
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ActivityInfoID:items.ID,
        
        }
        var that = this
        this.ajax('delActivityInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
            
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
     },
    // 编辑、增加页面保存方法
    // submitForm(editData) {
    //   this.$refs[editData].validate((valid) => {
    //     if (valid) {
    //       deptSave(this.ruleFormGG)
    //         .then((res) => {
    //           this.showDrawer = false;
    //           this.loading = false;
    //           if (res.success) {
    //             this.getdata(this.formInline);
    //             this.$message({
    //               type: "success",
    //               message: "公司保存成功！",
    //             });
    //           } else {
  
    //           }
    //         })
    //         .catch((err) => {
    //           this.showDrawer = false;
    //           this.loading = false;
    //           this.$message.error("公司保存失败，请稍后再试！");
    //         });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // 删除公司
   
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.showDrawer = false;
    },
  },
};
</script>
<style scoped>
.set-link {
  cursor:pointer !important;
      color: #409EFF;
 }

.rankingList___2qU5M li span:last-child {
    float: right;
}
.rankingList___2qU5M li span.active___3n5dI {
    background-color: #fab938 !important;
    color: #fff !important;
}
.rankingList___2qU5M li span:first-child {
    background-color: #f5f5f5;
    border-radius: 20px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    color:black;
}
.rankingList___2qU5M li{
    zoom: 1;
    margin-top: 16px;
}
.rankingList___2qU5M li span {
    color: rgba(0,0,0,.65);
    font-size: 12px;
    line-height: 22px;
}
.rankingList___2qU5M {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    height: 300px;
    overflow:auto;
}
.bottomTitle{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    line-height: 20px;
}
.bottomTitle1{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    /* line-height: 20px; */
}
.rmb{
  font-size: 12px; line-height: 1;
}
.money{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
}
.textTitle{
    margin-right: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
    line-height: 22px;
}
 .box{
    cursor: pointer;
    width: 24%;
    height: 160px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .box1{
 
    width: 74.7%;
    height: 362px;
    /* padding: 20px; */
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    /* border: 1px solid #ececec; */
    /* box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%); */
  }
  .box2{
    cursor: pointer;
    width: 24%;
    height: 362px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .pm{
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
  }

 .box3{
    cursor: pointer;
    width: 24%;
    height: 130px;
    
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box3Ttile{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
  }
  .num{
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
  }
   .box4{
    cursor: pointer;
    width: 24%;
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
   border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
 .box5{
    cursor: pointer;
    height: 200px;
    width:180px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
</style>

 



// WEBPACK FOOTER //
// src/views/marketing/LadderSpellGroupAcinfo.vue